import React, { CSSProperties } from 'react';
import { isMobile } from 'react-device-detect';
import { Badge, Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import * as Icons from '@ant-design/icons';
import { IComponentItem } from '../components/infrastructure/models';
import AppContext, { AppContextProps } from '../components/infrastructure/appContext';
import * as AllComponents from './components';
const { SubMenu } = Menu;
const { Sider } = Layout;

interface NsMenuState {
    rootSubmenuKeys: string[];
    openKeys: string[];
}

interface NsMenuProps {
    selectedKey?: string | undefined;
    components: IComponentItem[];
}

export class MainMenu extends React.Component<NsMenuProps, NsMenuState> {
    static contextType = AppContext;
    static displayName = MainMenu.name;
    mounted: boolean = false;

    sider?: HTMLDivElement | null;

    isSmallWindow: boolean = false;
    constructor(props: NsMenuProps) {
        super(props);

        this.state = {
            rootSubmenuKeys: this.props.components.filter(m => m.ParentId === null).map(m => m.Id),
            openKeys: []
        };
        this.isSmallWindow = isMobile || window.matchMedia('(max-width: 575px)').matches;
    }
    onDragEndMenu = (e: React.DragEvent<HTMLLIElement>, menuItem: IComponentItem) => {
        document.elementFromPoint(e.clientX, e.clientY)?.closest("#content-container")?.dispatchEvent(new CustomEvent('dragEndMenuItem', { detail: menuItem }));
    }
    renderMenu(parentid: string | null = null) {
        let _self = this;
        const { getPanelInfo } = this.context as AppContextProps;
        const panelInfo = getPanelInfo();

        return this.props.components.filter(c => c.ParentId === parentid && (!c.Path || ((AllComponents as any)[c.Item!.split('?')[0]])))
            .map(c => {
                const count = c.Path
                    ? panelInfo && panelInfo.data.filter(d => d.key === c.Id).length
                    : panelInfo && this.props.components.filter(s => s.ParentId === c.Id && !!panelInfo.data.find(d => d.key === s.Id))
                        .map(s => panelInfo.data.filter(d => d.key === s.Id))
                        .reduce((a, b) => a + b.length, 0);

                const title = (
                    <>
                        {c.Title}
                        {!!count && <Badge className="menuitem-badge" size="small" count={count}></Badge>}
                    </>
                );

                return c.Path ?
                    (
                        <Menu.Item
                            style={{ height: 32, lineHeight: "32px" }}
                            key={c.Path}
                            icon={_self.getIcon(c.Icon)}
                            onDragEnd={e => this.onDragEndMenu(e, c)}
                            draggable={true}
                        >
                            <Link
                                key={c.Path}
                                to={c.Id === "Home" ? "/" : '/refresh?' + encodeURIComponent(c.Path)}
                                onClick={() => {
                                    if (this.isSmallWindow) {
                                        const { setSidebarCollapsed } = this.context as AppContextProps;
                                        setSidebarCollapsed(true);
                                    }
                                }}
                            >
                                {title}
                            </Link>
                        </Menu.Item>)
                    : <SubMenu key={c.Id} title={title} icon={_self.getIcon(c.Icon)}>{_self.renderMenu(c.Id)} </SubMenu>
            });
    }
    getIcon(name?: string) {
        const Icon = name ? (Icons as any)[name] : null;
        if (Icon)
            return <Icon />;
    }
    handleClickOutside = (event: MouseEvent) => {
        if (!this.mounted)
            return;

        const { sidebarCollapsed } = this.context as AppContextProps;
        if (this.sider && !this.sider.contains(event.target as any) && this.isSmallWindow && !sidebarCollapsed) {
            let triggers = document.getElementsByClassName("trigger");
            if (triggers.length) {
                let trigger = triggers[0] as any;
                if (trigger.click)
                    trigger.click();
            }
        }
    }
    componentDidMount() {
        this.mounted = true;
        document.addEventListener("mousedown", this.handleClickOutside);

        const { getUserInfo } = this.context as AppContextProps;
        const userInfo = getUserInfo();

        const defautltOpenMenu = userInfo?.extraVariables["PolicyholderId"] ? ['PolicyholderPortal'] : [];
        if (defautltOpenMenu.length)
            this.setState({ openKeys: defautltOpenMenu });
        else
            this.forceUpdate();
    }
    componentWillUnmount() {
        this.mounted = false;
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    onOpenChange = (keys: string[]) => {
        const latestOpenKey = keys.find(key => this.state.openKeys.indexOf(key) === -1)!;
        if (this.state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys: keys });
        } else {
            this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
        }
    }
    render() {
        if (!this.mounted)
            return <></>;

        const { path } = this.context;
        const collapseWidth = this.isSmallWindow ? 0 : undefined;
        const style: CSSProperties | undefined = this.isSmallWindow ? { position: "absolute", height: "100vh", zIndex: 1001 } : {};

        const { sidebarCollapsed } = this.context as AppContextProps;

        return (
            <Sider
                ref={node => this.sider = node}
                trigger={null}
                collapsible
                collapsed={sidebarCollapsed}
                className="custom-scroll"
                style={{ maxWidth: 300, overflowX: 'auto', ...style }}
                width={sidebarCollapsed ? undefined : "max-content"}
                collapsedWidth={collapseWidth}
                breakpoint="lg"
                onBreakpoint={broken => {
                    const { setSidebarCollapsed } = this.context as AppContextProps;
                    setSidebarCollapsed(broken);
                }}
                onCollapse={(collapsed, _type) => {
                    const { setSidebarCollapsed } = this.context as AppContextProps;
                    setSidebarCollapsed(collapsed);
                }}

            >
                <Menu theme="dark"
                    mode="inline"
                    style={{ width: "100%" }}
                    openKeys={this.state.openKeys}
                    onOpenChange={this.onOpenChange}
                    defaultSelectedKeys={[path ?? '/']}
                >
                    {this.renderMenu()}
                </Menu>
            </Sider>
        );
    }
}
